<template>
  <div id="bottom-navigation" class="w-100 bg-white">
    <div class="d-flex flex-justify-between w-100" style="height: 64px">
      <div class="d-flex flex-align-center flex-justify-center h-100 pb-2 c-pointer" style="flex-basis: 100%"
           @click="safeRouterPush(option.path)" v-for="option in optionsMenu" v-if="!option.dontShow">
        <div class="w-100 h-100 d-flex flex-column flex-align-center flex-justify-end"
             :class="{'border-top border-size-3' : option.path.name === $route.name}" style="border-color: #fa6800">
          <template v-if="option.path.name === $route.name">
            <div style="color: #fa6800">
              <i :class="option.icon"></i>
            </div>
            <div class="text-upper mt-1" style="font-size: 10px; font-weight: 500; color: #669C35">
              {{ option.title }}
            </div>
          </template>
          <template v-else>
            <div>
              <i :class="option.icon"></i>
            </div>
            <div class="text-upper mt-1" style="font-size: 10px; font-weight: 500">
              {{ option.title }}
            </div>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "bottom-navigation",
  computed: {
    optionsMenu() {
      return [
        {
          id: 1,
          icon: "fa-solid fa-house-chimney",
          title: "Inicio",
          path: {name: "menu_principal"},
        },
        {
          id: 2,
          icon: "fa-solid fa-shop",
          title: "MarketPlace",
          path: {name: 'home_ds',}
        },
        {
          id: 3,
          icon: "fa-solid fa-table-list",
          title: "Categorias",
          path: {name: "categorias_ds"},
        },
        {
          id: 4,
          icon: "fa-brands fa-opencart",
          title: "Carrito",
          path: {name: 'carrito_compras'},
          dontShow: !this.user_computed || this.user_computed.is_departamento
        },
        {
          id: 5,
          icon: "fa-solid fa-bars",
          title: "Menu",
          path: {name: 'menu'}
        },
      ]
    }
  },
  methods: {
    safeRouterPush(route) {
      if (route.name !== this.$route.name) {
        this.$router.push(route)
      }
    }
  }
}
</script>

<style scoped>
#bottom-navigation {
  color: #0000008a;
  box-shadow: 0 0 5px 0 #eee;
  line-height: 1.5;
  max-width: 100vw;
  bottom: 0;
  position: sticky;
  padding-bottom: var(--safe-area-inset-bottom);
}
</style>